
import { Component, Prop, Vue } from 'vue-property-decorator'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import { updateInfo } from '@/apis/myInfo/myInfo'
import i18n from '@/lang';

@Component({})
export default class AddTeachLesson extends Vue {
  private info = this.$store.state.userInfo
  private lessonList: any = []
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  addLesson() {
    const input: any = this.$refs.input
    if (input) {
      for (let i = 0; i < input.length; i++) {
        this.lessonList[i] = input[i].value
      }
    }

    if (this.lessonList[this.lessonList.length - 1] == '' && this.lessonList.length > 0) {
      return
    } else {
      this.lessonList.push('')
    }
  }
  removeLesson(index: number) {
    this.lessonList.splice(index, 1)
  }
  keep() {
    const input: any = this.$refs.input
    for (let i = 0; i < input.length; i++) {
      this.lessonList[i] = input[i].value
    }
    for(let j = 0;j <this.lessonList.length;j ++){
      if(this.lessonList[j] == ''){
        this.lessonList.splice(j,1)
        j --
      }
    }
    // if (this.lessonList[this.lessonList.length - 1] == '') {
    //   this.lessonList.pop()
    // }

    updateInfo({
      username: this.userInfo.username,
      school: this.userInfo.school,
      department: this.userInfo.department,
      teachcourse: this.lessonList,
      stno: this.userInfo.stno,
      majors: this.userInfo.majors,
      classno: this.userInfo.additionInfo!.classno,
      enrolltime: this.userInfo.additionInfo!.enrolltime,
      grade: this.userInfo.additionInfo!.grade,
    })
      .then((res) => {
        this.$store.dispatch('setUserInfo').then(() => {
          this.$router.back()
        })
      })
      .catch((e) => {})
  }
  created() {
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('Home.课程') as string,
      showTitle: true,
    })
    this.lessonList = this.userInfo.teachcourse
  }
}
